import {IncomingTransferIcon} from './incoming/incoming.transfer.icon';
import {FeeTransferIcon} from './fee/fee.transfer.icon';
import {InternalTransferIcon} from './internal/internal.transfer.icon';
import {OutgoingExchangeTransferIcon} from './outgoing/outgoing.exchange.transfer.icon';
import {Outgoing3TransferIcon} from './outgoing/outgoing.3.transter.icon';
import {Outgoing4TransferIcon} from './outgoing/outgoing.4.transfer.icon';
import {DeliveredTransferIcon} from './delivered/deivered.transfer.icon';
import {UndeliveredTransferIcon} from './undelivered/undelivered.transfer.icon';
import {Incoming4TransferIcon} from './incoming/incoming.4.transfer.icon';
import {RefundTransferIcon} from './refund/refund.transfer.icon';
import {OutgoingTransferIcon} from './outgoing/outgoing.transfer.icon';
import {InternalExchangeTransferIcon} from './internal/internal.exchnage.transfer.icon';
import {SystemTransferIcon} from './system/system.transfer.icon';
import {SystemExchangeTransferIcon} from './system/system.exchange.transfer.icon';
import {CardExchangeTransferIcon} from './card/card.exchange.transfer.icon';
import {CardTransferIcon} from './card/card.transfer.icon';

export const TRANSFER_ICONS = [
    IncomingTransferIcon,
    RefundTransferIcon,
    Incoming4TransferIcon,
    UndeliveredTransferIcon,
    DeliveredTransferIcon,
    Outgoing4TransferIcon,
    Outgoing3TransferIcon,
    OutgoingExchangeTransferIcon,
    OutgoingTransferIcon,
    InternalExchangeTransferIcon,
    InternalTransferIcon,
    FeeTransferIcon,
    CardExchangeTransferIcon,
    CardTransferIcon,
    SystemTransferIcon,
    SystemExchangeTransferIcon
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/index.ts